import {
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  FormHelperText,
  createStyles,
  makeStyles,
  FormControl
} from '@material-ui/core';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {INPUT_LABEL_COLOR} from 'src/style/variable';

interface ICheckboxInputField extends CheckboxProps {
  label: string;
  onChange: (value: any) => void;
  error?: Record<string, any>;
}

const useStyles = makeStyles(() => {
  return createStyles({
    formControlLabel: {
      margin: 0,
      marginLeft: '-6px',
      '& .MuiButtonBase-root': {
        padding: '4px'
      },
      '& .MuiFormControlLabel-label': {
        marginTop: '0rem',
        fontSize: '1.1rem',
        color: INPUT_LABEL_COLOR
      }
    },
    formControl: {
      paddingBottom: 0,
      marginBottom: 0
    }
  });
});

const SingleCheckboxInputField = ({
  label,
  error,
  ...rest
}: ICheckboxInputField): JSX.Element => {
  const classes = useStyles();
  const {t} = useTranslation();
  return (
    <FormControl error={!!error} className={classes.formControl}>
      <FormControlLabel
        className={classes.formControlLabel}
        control={
          <Checkbox
            checked={!!rest.value}
            {...rest}
            onChange={e => {
              if (rest.onChange) {
                rest.onChange(e.target.checked);
              }
            }}
          />
        }
        label={label}
      />
      {error && <FormHelperText>{t(error.message)}</FormHelperText>}
    </FormControl>
  );
};

export default SingleCheckboxInputField;
